// client/src/routes/app/equipment/index.tsx — SCR-EQP-001 · MAINT-006 (04 §8.9).
//
// Replaces UI-003's `PlaceholderScreen`, which named this item as its owner.
//
// The route owns the URL state and nothing else: `validateSearch` runs the §9.2.3 schema and the
// screen reads it back typed, so a filtered register is shareable, survives refresh, and Back is
// a filter-undo.
//
// `Operations.Read` is UI-003's guard and stays: the sidebar hides the entry, and this renders
// SCR-SYS-403 for the URL that was typed anyway (§9.2.2). Every write — the „adaugă" button, the
// edit, the revision — is mirrored against `Operations.Write`, which the `accountant` role does
// not hold (and neither does it hold `Operations.Read`, so it never reaches this screen).

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { EquipmentRegister } from '@/features/equipment/EquipmentRegister';
import { equipmentSearchSchema, type EquipmentSearch } from '@/features/equipment/search';

export const Route = createFileRoute('/app/equipment/')({
  validateSearch: equipmentSearchSchema,
  component: EquipmentScreen,
});

function EquipmentScreen() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Operations.Read">
      <EquipmentRegister
        search={search}
        onSearchChange={(next: (previous: EquipmentSearch) => EquipmentSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
